import React from 'react';
import {Link} from 'react-router-dom';
import Lightbox from "yet-another-react-lightbox";
import MetaTags from "../components/MetaTags";

const Shnur: React.FC = () => {
    const [open, setOpen] = React.useState(false);
    const [image, setImage] = React.useState<number>(0);

    const images = [
        {src: "/image/Bousi/kP3120096.jpg"},
        {src: "/image/Bousi/kP1220106.jpg"},
    ];

    const viewImage = (event: any) => {
        setOpen(true)
        setImage(Number(event.target.id.replace(/\D/g, '')))
    }

    MetaTags(
        "Шнур из бисера - схема плетения",
        "Шнур из бисера&nbsp;— схемы плетения двух видов шнура - сплошного и ажурного. Примеры колье основе этих шнуров."
    )

    return <>
        <h2>Шнур из бисера - схема плетения</h2>
        <p>Шнур плетется кругом снизу вверх. Для первого ряда можно набирать любое количество бисеринок, главное чтобы
            оно было нечетным.</p>
        <p>Сначала набираем 7 бисеринок на леску и соединяем их в кольцо, пропустив леску через первую бисеринку, как
            показано на рисунке А. Набираем 8-ю бисеринку и продеваем леску через 3-ю (рис. Б). Набираем 9-ю бисеринку и
            пропускаем леску через 5-ю, потом&nbsp;— еще одну бисеринку и продеваем леску в 7-ю бисеринку (рис. В).
            Далее набираем 12-ю бисеринку и проводим леску через 8-ю, набираем следующую 13-ю бисеринку и продеваем
            леску через 10-ю, потом 14-ю&nbsp;— леска проходит через 11-ю (рис. Г).</p>
        <p>Ряды прибавляются в высоту&nbsp;— должна получиться трубочка пустая внутри. Продолжаем плетение так же:
            набираем по одной бисеринке и продеваем леску через бисеринки предыдущего ряда. Этот вид плетения шнура
            можно назвать плотным, т.к. в нем практически нет просветов.</p>

        <img src="/image/Schema/shnur.jpg" className="schema col-centered img-responsive" width="550" height="200"
             alt="ШНУР ИЗ БИСЕРА&nbsp;— СХЕМА ПЛЕТЕНИЯ"/>
        <p>На основе шнура можно сделать много интересных вещей. Например, соединить шнур в кольцо, украсить подвесками,
            прикрепить петельку&nbsp;— получится оригинальный брелок. Или сделать кулон, подвесив колечко из шнура на
            бисерную нить.</p>

        <div className="row">
            <div className="col-md-12">
                <img
                    src="/image/Bousi/mP3120096.jpg" className="pic-left img-rounded"
                    width="170" height="227"
                    alt="Колье из плотного шнура"
                    id="image-0"
                    onClick={viewImage}
                />

                <p>Пример колье, изготовленного на основе шнура. Для шнура я использовала крупный бисер 5 цветов.
                    Для первого ряда взяла 5 бисеринок разных цветов. Чтобы бисеринки одного цвета следовали друг за
                    другом, необходимо каждую вновь набранную бисеринку располагать над такой же по цвету.<br/>
                    Я сплела кусок шнура и продела сквозь него бисерную нить, т.к. шнур пустой внутри, прикрепила
                    застежку и получилось колье.<br/>
                    Чтобы узор выглядел спиралевидным, нужно немного подкрутить шнур пальцами.</p>

            </div>
        </div>
        <h2>Ажурный шнур из бисера</h2>

        <p>Набираем на леску 11 бисеринок и соединяем их в колечко (рис. А). Набираем еще 3 бисеринки и продеваем леску
            через 4-ю. Затем&nbsp;— еще 3 бисеринки и пропускаем леску через 7-ю, потом&nbsp;— еще 3 и леску проводим
            через 10-ю бисеринку (рис.Б).</p>
        <p>При плетении ажурного шнура средняя бисеринка из трех является связующей. Поэтому для продолжения плетения
            набираем еще 3 бисеринки и продеваем леску через 13-ю (среднюю из трех набранных бисеринок, набранных в
            прошлом ряду). Продолжаем плетение так, как показано на рисунке В. Следующие ряды плетутся так же.</p>

        <img src="/image/Schema/shnur_ajour.jpg" className="schema col-centered img-responsive" width="550" height="240"
             alt="АЖУРНЫЙ ШНУР ИЗ БИСЕРА"/>
        <div className="row">
            <div className="col-md-12">
                <img src="/image/Bousi/mP1220106.jpg" className="pic-left img-rounded" width="170" height="227"
                     alt="Ажурный комплект"
                     id="image-1"
                     onClick={viewImage}/>
                <p>А вот пример колье на основе ажурного шнура. Здесь я использовала как бисер, так и короткий
                    стеклярус. В качестве связующих я использовала по одной бисеринке,
                    а остальные заменила на связку&nbsp;— бисеринка-стеклярус-бисеринка. Получился прозрачный воздушный
                    шнур. По краям цепочки желательно уменьшать количество бисеринок,
                    чтобы сделать плавный переход между объемным шнуром и тонкой бисерной нитью.<br/>
                    Сережки выполнены в той же цветовой гамме, но уже в другой технике.<br/>
                    Читайте: <Link to="/opletenie-bousin">оплетение бусин бисером и стеклярусом</Link>.</p>
            </div>
        </div>
        <Lightbox
            open={open}
            close={() => setOpen(false)}
            slides={[
                images[image], // Выбранный элемент
                ...images.slice(0, image), // Элементы до выбранного
                ...images.slice(image + 1) // Элементы после выбранного
            ]}
        />
    </>;
};

export default Shnur;

